import { DropdownMenuItem } from "@acdc2/ui/components/dropdown-menu";
import { mdiLogout } from "@mdi/js";
import { Icon } from "@mdi/react";
import { useTranslation } from "react-i18next";
import { useAuth } from "react-oidc-context";

export function ViewerLogoutDropdownMenuItem() {
  const { t } = useTranslation();
  const auth = useAuth();

  const onClick = () => {
    auth.removeUser();
  };

  return (
    <DropdownMenuItem onClick={onClick}>
      <Icon path={mdiLogout} size="1.25rem" />
      {t("ViewerLogoutDropdownMenuItem.label")}
    </DropdownMenuItem>
  );
}
